import type { VueRoute } from "ui-kit/RouterVue";
import { h } from "vue";

const route: VueRoute = {
  path: "/custom-fields/:slug?",
  action: async ({ pathname }) => {
    const id = pathname.groups.slug;
    const c = id
      ? await import("./views/fieldEdit.vue")
      : await import("./views/fields.vue");
    return h(c.default, { id });
  },
};

export default route;
